import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  accountType?: 'founder' | 'group_a' | 'owner';
  requireVerification?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  accountType, 
  requireVerification = true 
}) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check email verification if required
  if (requireVerification && !user.isEmailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  // Check account type if specified
  if (accountType && user.accountType !== accountType) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 